import { requestPost } from '../../utils/request';

const BASE_URL = '/api/weather/v4';

export async function requestCurrentConditionsByLocation(lat, long, userId) {
  return requestPost(`${BASE_URL}/current-conditions`, {
    data: {
      locations: [
        {
          latitude: lat,
          longitude: long,
        },
      ]
    },
    headers: { 'x-user-id': userId, 'x-stub': false },
    mockFile: 'weather/currentConditionsByLocation',
  });
}

export async function requestHourlyForecastByLocation(lat, long, userId) {
  return requestPost(`${BASE_URL}/hourly-forecast`, {
    data: {
      locations: [
        {
          latitude: lat,
          longitude: long,
        },
      ],
      'hours-forward': 24,
    },
    headers: { 'x-user-id': userId, 'x-stub': false },
    mockFile: 'weather/hourlyForecastByLocation',
  });
}

export async function requestDailyForecastByLocation(lat, long, userId) {
  return requestPost(`${BASE_URL}/daily-forecast`, {
    data: {
      locations: [
        {
          latitude: lat,
          longitude: long,
        },
      ],
      "days-forward": 7
    },
    headers: { 'x-user-id': userId, 'x-stub': false },
    mockFile: 'weather/dailyForecastByLocation',
  });
}
